module.exports = __webpack_public_path__ + "static/media/map2.d92064e2.jpg";